import { useEffect, RefObject } from 'react';

type Handler = (event: MouseEvent) => void;

function useClickOutside<T extends HTMLElement>(
  ref: RefObject<T | null>,
  handler: Handler
): void {
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      const target = event.target;

      if (target instanceof Node && ref.current && !ref.current.contains(target)) {
        handler(event);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, handler]);
}

export default useClickOutside;